import { render, staticRenderFns } from "./FullIndex.vue?vue&type=template&id=60fe7086&scoped=true"
import script from "./FullIndex.vue?vue&type=script&lang=js"
export * from "./FullIndex.vue?vue&type=script&lang=js"
import style0 from "./FullIndex.vue?vue&type=style&index=0&id=60fe7086&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60fe7086",
  null
  
)

export default component.exports